export default __webpack_public_path__ + "static/media/template_03.e7e9d7b0.jpg";